export const MOST_SEARCHED_ADS_ATTEMPT = "MOST_SEARCHED_ADS_ATTEMPT";
export const MOST_SEARCHED_ADS_SUCCESS = "MOST_SEARCHED_ADS_SUCCESS";
export const MOST_SEARCHED_ADS_FAILED = "MOST_SEARCHED_ADS_FAILED";
